import { ThemeInterface } from "@styles/theme";

const styles = (theme: ThemeInterface) => ({
	root: {
		overflow: "auto",
		display: "flex",
		flexFlow: "column",
		height: "100%",
		backgroundColor: theme.palette.blueGrey.light,
	},
	appBar: {
		zIndex: theme.zIndex.drawer + 1,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		display: "flex",
		flexDirection: "row",
		position: "sticky",
	},
	layoutMainContainer: {
		height: "100%",
	},
});

export default styles;
